import AxiosService from "@/services/AxiosService";

class SubAccsService {
  getSubAccs(payload) {
    return AxiosService.get(`/subaccounts`, { params: payload })
      .then((resp) => {
        return resp.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  async getSubAcc(payload) {
    return await AxiosService.get(`/subaccount/${payload}`, {})
      .then((resp) => {
        return resp.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  async getSelfHostedScriptStatus(id) {
    return AxiosService.get(`/subaccount/${id}/self-hosted-script/status`)
      .then((resp) => {
        return resp.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  async getSelfHostedScriptSetup(id, apiKeyId) {
    return AxiosService.get(`/subaccount/${id}/self-hosted-script/setup`, { params: apiKeyId ? { api_key_id: apiKeyId } : {} })
      .then((resp) => {
        return resp.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // Resolves to { blob, filename } on success or to the API error answer ({ status, message })
  async downloadSelfHostedScript(id) {
    return AxiosService.get(`/subaccount/${id}/self-hosted-script`, { responseType: "blob" })
      .then(async (resp) => {
        if (resp.data.type && resp.data.type.includes("application/json")) {
          return JSON.parse(await resp.data.text());
        }
        const disposition = resp.headers["content-disposition"] || "";
        const match = disposition.match(/filename="?([^";]+)"?/);
        return { blob: resp.data, filename: match ? match[1] : `sitelib-${id}.js` };
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  async getFile() {
    return AxiosService.get("/subaccount/generate-file")
      .then((resp) => {
        return resp.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  async getDNS() {
    return AxiosService.get("/subaccount/generate-dns")
      .then((resp) => {
        return resp.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  async checkSite(payload) {
    return AxiosService.post("/subaccount/check-site", payload)
      .then((resp) => {
        return resp.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // Checks the site of a platform and remembers when it was confirmed
  async verifySubAcc({ id, check_type }) {
    return AxiosService.post(`/subaccount/${id}/verify`, { check_type })
      .then((resp) => {
        return resp.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  changeFacebookRedirect(id, payload) {
    return AxiosService.patch(
      `/subaccount/${id}/facebook-web-view-redirect`,
      payload
    )
      .then((resp) => {
        return resp.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getLandings() {
    return AxiosService.get("/landings", {})
      .then((resp) => {
        return resp.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  getDomainSubAccs(id) {
    return AxiosService.get(`/domains/${id}/subaccs`, {})
      .then((resp) => {
        return resp.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  async saveDomainSubAccs(id,ids) {
    return await AxiosService.post(`/domains/${id}/subaccs`, {
      subaccs: ids
    })
      .then((resp) => {
        return resp.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }


  async cloneSubAcc(payload) {
    return await AxiosService.post(`/subaccount/${payload}/clone`)
      .then((resp) => {
        return resp.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  async trashSubAcc(payload) {
    return await AxiosService.patch(`/subaccount/${payload.id}/trash`, {
      trash: +!payload.trash,
    })
      .then((resp) => {
        return resp.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  async updateSubAcc(payload) {
    return await AxiosService.put(`/subaccount/${payload.id}`, payload.params)
      .then((resp) => {
        return resp.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  async finishSubAcc(payload) {
    return await AxiosService.put(
      `/subaccount/${payload.id}?is_new=true`,
      payload.params
    )
      .then((resp) => {
        return resp.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  async createSubAcc(payload) {
    return await AxiosService.post("/subaccount", payload)
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }
}

export default new SubAccsService();
